import React, { useState, useEffect } from "react";

import { GeneralModal, FormInput_text, FormInput_textarea } from "components";

import { func_validation } from "functions";
import { outletColumns } from "../outletColumns";



export function useOutletControl(props) {
    const { 
        packageList,

        comID,

        getPackageList_requesting,

        getOutletList_requesting, 
        outletList, outletListHeaders,

        addOutlet_requesting, addOutlet_status,
    } = props;

    let comID_validated = func_validation.isNotNullUndefined(comID)? comID: "";


    // States
    
    const [isOutletModalVisible, setIsOutletModalVisible] = useState(false);

    const [outletName, setOutletName] = useState("");
    const [printedName, setPrintedName] = useState("");
    const [printedAddress, setPrintedAddress] = useState("");
    const [isAddOutletAttempted, setIsAddOutletAttempted] = useState(false);


    function getOutletList(pageNo, pageSize, sort, filterOptions) {
        if (props.getOutletList)
            props.getOutletList(comID_validated, pageNo, pageSize, sort, filterOptions);
    }

    function handleAddOutlet() {
        setIsAddOutletAttempted(true);

        if (func_validation.isStringTrimNotEmpty(outletName) &&
            func_validation.isStringTrimNotEmpty(printedName) &&
            func_validation.isStringTrimNotEmpty(printedAddress) &&
            props.addOutlet) {

            let outletInfo = {
                "outletName": outletName,
                "printedName": printedName,
                "printedAddress": printedAddress
            };
            
            props.addOutlet(outletInfo);
        }
    }

    useEffect(() => {
        setIsAddOutletAttempted(false);
    }, [isOutletModalVisible]);
    useEffect(() => {
        if (func_validation.isBooleanTrueNotNullUndefined(addOutlet_status) &&
            props.setIsOutletModalVisible)
            props.setIsOutletModalVisible(false);
    }, [addOutlet_status]);


    let outletOptions = [];
    if (func_validation.isArrayNotEmpty(packageList)) {
        outletOptions = packageList.map((packageDetails, idx) => {
            let packageId = func_validation.getObjectPropertyValue(packageDetails, "packageId");
            let packageName = func_validation.getObjectPropertyValue(packageDetails, "packageName");

            return {
                label: packageName,
                value: packageId
            }
        });
    }

    let addOutletModal = (
        <GeneralModal
            modalWapperClassName={"distributorPortal-companyOverview-outletModal"}
            isModalVisible={isOutletModalVisible}

            title={"Add Outlet"}
            headerClassName={"distributorPortal-companyOverview-outletModal-header"}
            
            updateParentState={setIsOutletModalVisible}

            bodyWrapperClassName={"distributorPortal-companyOverview-outletModal-content"}
            content={(
                <React.Fragment>
                    {/* Outlet Name */}
                    <FormInput_text
                        className={"distributorPortal-companyOverview-outletModal-outletName"}
                        customInputClassName={"distributorPortal-companyOverview-outletModal-outletName-input"}
                        inputValue={outletName}
                        propagateValueChange={(stateName, value) => { setOutletName(value); }}

                        inputLabel={"Outlet Name"}

                        customErrorMsg={"Required"}
                        isFormSubmissionAttempted={isAddOutletAttempted}

                        isMarginBtmOptional
                    />

                    {/* Printed Name */}
                    <FormInput_text
                        className={"distributorPortal-companyOverview-outletModal-printedName"}
                        customInputClassName={"distributorPortal-companyOverview-outletModal-printedName-input"}
                        inputValue={printedName}
                        propagateValueChange={(stateName, value) => { setPrintedName(value); }}

                        inputLabel={"Printed Name"}

                        customErrorMsg={"Required"}
                        isFormSubmissionAttempted={isAddOutletAttempted}

                        isMarginBtmOptional
                    />

                    {/* Printed Address */}
                    <FormInput_textarea
                        className={"distributorPortal-companyOverview-outletModal-printedAddress"}
                        customInputClassName={"distributorPortal-companyOverview-outletModal-printedAddress-input"}
                        inputValue={printedAddress}
                        propagateValueChange={(stateName, value) => { setPrintedAddress(value); }}

                        inputLabel={"Printed Address"}

                        customErrorMsg={"Required"}
                        isFormSubmissionAttempted={isAddOutletAttempted}

                        isMarginBtmOptional
                    />
                </React.Fragment>
            )}

            footerClassName={"distributorPortal-companyOverview-outletModal-footer"}
            confirmButtonText={"Add"}
            handleOnConfirm={handleAddOutlet}
            isConfirmSuccessful={addOutlet_status}
            confirmButtonProps={{
                isLoading: addOutlet_requesting
            }}
            isConfirmButtonVisible
        />
    );

    return {
        getOutletList,
        addOutletModal,

        addOutlet_status,
        getOutletList_requesting, 
        outletList, outletListHeaders,

        outletColumns: outletColumns.getColumns(props),

        setIsOutletModalVisible
    };
}
